import { MetaRatingIcon, fullIncreaseIcon } from "@/designSystemIcons";
import { metaRatingUpgradeFormatter } from "@/functions/metaRatingUpgradeFormatter";
import { cn } from "@/lib/utils";

type Props = {
  metaRating?: number;
  delta?: number;
  className?: string;
};

export const MetaRatingDelta = ({ metaRating, delta, className }: Props) => (
  <div
    className={cn(
      "content-stretch flex gap-1 items-start relative rounded shrink-0 justify-end text-base",
      className,
    )}
  >
    {metaRating > 0 && (
      <>
        <div className="content-stretch flex gap-1 items-center relative shrink-0">
          <p className="font-bold relative shrink-0 text-dark-secondary text-nowrap whitespace-pre leading-3">
            {metaRating?.toFixed(1)}
          </p>
        </div>

        <div className="content-stretch flex gap-1 items-start justify-center relative shrink-0 text-dark-tertiary">
          <MetaRatingIcon width="12" height="12" />
        </div>
      </>
    )}
    {delta > 0 && (
      <div className="content-stretch flex items-start justify-center relative shrink-0 gap-x-0.5">
        <div className="size-2 text-ea-dark-green">{fullIncreaseIcon}</div>
        <div className="flex flex-col justify-center leading-3 relative shrink-0 text-ea-dark-green text-nowrap font-bold">
          <p className="whitespace-pre">{metaRatingUpgradeFormatter(delta)}</p>
        </div>
      </div>
    )}
  </div>
);
